import { useVdjCacheIndex } from '../../hooks/useVdjCacheIndex';

/** Starts VDJ cache indexing after load when the preference is on. Renders nothing. */
export default function VdjCacheIndexBootstrap() {
  useVdjCacheIndex();
  return null;
}
